var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFavMultiOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 42 42",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.812 33.978V2.599H13.047v3.019l-6.849.963.445 3.166-6.671 1.913 8.65 30.164 26.643-7.64 1.46-.205zM15.662 5.214h23.535v26.149H15.662zm-2.615 2.797v25.967h6.65l-7.114 1-3.708-26.38zm-2.8 30.881L2.904 13.285l4.073-1.168 3.589 25.539 7.837-1.102z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m39.322 15.186-8.096-1.285-3.621-8.01-3.621 8.01-8.096 1.285 5.858 6.235-1.383 8.804 7.242-4.156 7.242 4.156-1.383-8.804zm-11.717 8.906-5.114 2.936.976-6.217-4.137-4.403 5.717-.907 2.557-5.657 2.557 5.657 5.717.907-4.137 4.403.976 6.217c.002-.001-5.112-2.936-5.112-2.936"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFavMultiOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fav-multi-off.svg";